import { createContext } from "react";
import type { Locale } from "./supported";

export interface LocaleContextValue {
  locale: Locale;
  setLocale: (next: Locale) => void;
}

/**
 * React context for the active locale. Kept in its own file so the
 * `LocaleProvider` module only exports components — required for
 * `react-refresh/only-export-components` (Vite Fast Refresh).
 */
export const LocaleContext = createContext<LocaleContextValue | null>(null);
